<template>
    <div class="deliverySchedule__card pt-4 pb-6 lg:pt-0 lg:pb-2">
        <vue-flip width="100%" :bindWithMe="front" height="0">
            <delivery-card slot="front"
                :address="address"
                @holiday-button-clicked="flip"
                @has-recently-skipped-delivery="showModal = true"/>

            <delivery-card slot="back"
                :address="address"
                @holiday-button-clicked="flip"
                @has-recently-skipped-delivery="showModal = true"/>
        </vue-flip>

        <holiday-cancellation-modal v-if="showHolidayCancellationModal"/>
    </div>
</template>

<script>
import VueFlip from 'vue-flip';
import DeliveryCard from '@/components/partials/account/my-delivery-schedule/deliveryCard/DeliveryCard';
import HolidayCancellationModal from '@/components/modals/HolidayCancellationModal';

export default {
    name: 'DeliveryCardContainer',
    components: {
        HolidayCancellationModal,
        DeliveryCard,
        VueFlip,
    },
    data() {
        return {
            front: true,
            showModal: false,
        };
    },
    props: {
        address: {
            required: true,
            type: Object,
        },
    },
    methods: {
        flip() {
            this.front = !this.front;
        },
    },
    computed: {
        deliveryDays() {
            return this.$store.getters['scheduledOrder/getDeliveryDays'];
        },
        holidays() {
            return this.$store.getters['scheduledOrder/getHolidays'];
        },
        optInDeliveryDays() {
            return this.$store.getters['scheduledOrder/getOptInDeliveryDays'];
        },
        showHolidayCancellationModal() {
            let notOptInDaysNumber = this.optInDeliveryDays.filter((day) => {
                let lastDelivery = this.deliveryDays[this.deliveryDays.length - 1];

                return day.date <= lastDelivery.date && day.id === null;
            }).length;

            return this.showModal && this.deliveryDays.length === (this.holidays.length + notOptInDaysNumber);
        },
    },
};
</script>
